export default "__VITE_PUBLIC_ASSET__39c56632__"